// extracted by css-extract-rspack-plugin
export default {"questionText":"questionText-4rthk","questionTextHtmlContainer":"questionTextHtmlContainer-1qpja"};